import api from "../http";
import {useStore} from "../contexts/AppContext";



export const useFetchData = () => {
    const {
        setDataLoading, documentTypes, setDocumentTypes, brands, setBrands, periods, setPeriods,
        countries, setCountries, advertiseResources, setAdvertiseResources, department,
        setDepartment,
    } = useStore();

    return async (signal) => {
        setDataLoading(true);
        try {
            if (!documentTypes.length) {
                const res = await api.get('supabase/document-types', { signal });
                if (res.status === 200 && !signal?.aborted) setDocumentTypes(res.data.data);
            }

            if (!brands.length) {
                const res = await api.get('supabase/brands', { signal });
                if (res.status === 200 && !signal?.aborted) setBrands(res.data.data);
            }

            if (!periods.length) {
                const res = await api.get('supabase/periods', { signal });
                if (res.status === 200 && !signal?.aborted) setPeriods(res.data.data);
            }

            if (!countries.length) {
                const res = await api.get('supabase/countries', { signal });
                if (res.status === 200 && !signal?.aborted) setCountries(res.data.data);
            }

            if (!advertiseResources.length) {
                const res = await api.get('supabase/advertise-resources', { signal });
                if (res.status === 200 && !signal?.aborted) setAdvertiseResources(res.data.data);
            }

            if (!department.length) {
                const res = await api.get('supabase/departments', { signal });
                if (res.status === 200 && !signal?.aborted) setDepartment(res.data.data);
            }
        } catch (e) {
            if (e.name !== 'AbortError' && e.name !== 'CanceledError') {
                console.log(e)
            }
        } finally {
            setDataLoading(false);
        }
    };
};
